module.exports = __webpack_public_path__ + "static/floral-d3715b15f01380efd244e7cf2965bc17.png";